const PRIVACY_POLICY_URL = `https://www.farmers.com/privacy-statement/`;

export { PRIVACY_POLICY_URL };
